import { AxiosRequestConfig } from 'axios'
import api from './api'

export const fetcher = (
  url: string,
  data: AxiosRequestConfig['params'],
  headers?: AxiosRequestConfig['headers']
) => api.get(url, { params: data, headers }).then((res) => res.data)
